module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'mobile-menu-mask': _vm.isMobile, 'on': _vm.isMobile && _vm.navToggle
    },
    attrs: {
      "id": "app"
    }
  }, [(!_vm.isMobile && !_vm.noLayout) ? _c('vue-header', {
    attrs: {
      "navHeight": _vm.fullScreenCount.navHeight,
      "isMobile": _vm.isMobile,
      "isLogin": _vm.isLogin,
      "navToggle": _vm.navToggle
    },
    on: {
      "update:navHeight": function($event) {
        _vm.fullScreenCount.navHeight = $event
      },
      "update:isLogin": function($event) {
        _vm.isLogin = $event
      },
      "update:navToggle": function($event) {
        _vm.navToggle = $event
      }
    }
  }) : _vm._e(), (_vm.isMobile && !_vm.noLayout) ? _c('vue-header-mobile', {
    attrs: {
      "navHeight": _vm.fullScreenCount.navHeight,
      "fullScreenCount": _vm.fullScreenCount,
      "isMobile": _vm.isMobile,
      "isPortrait": _vm.isPortrait,
      "isLogin": _vm.isLogin,
      "navToggle": _vm.navToggle
    },
    on: {
      "update:navHeight": function($event) {
        _vm.fullScreenCount.navHeight = $event
      },
      "update:isLogin": function($event) {
        _vm.isLogin = $event
      },
      "update:navToggle": function($event) {
        _vm.navToggle = $event
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "site-content",
    style: ({
      paddingBottom: _vm.$route.meta.mobileBtn && _vm.isMobile ? '48px' : '0px'
    })
  }, [_c('router-view', {
    style: ({
      paddingTop: _vm.navPaddingCount()
    }),
    attrs: {
      "fullScreenCount": _vm.fullScreenCount,
      "isMobile": _vm.isMobile,
      "isPortrait": _vm.isPortrait,
      "isLogin": _vm.isLogin
    }
  })], 1), (!_vm.noLayout) ? _c('vue-footer', {
    style: ({
      paddingBottom: _vm.$route.meta.mobileBtn && _vm.isMobile ? '48px' : '0px'
    }),
    attrs: {
      "isMobile": _vm.isMobile
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4585f144"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 567
// module chunks = 1